import { getMyMlsListings } from "@/services/v2/mlsListings";

// The tour's intro panel is inert, so it only needs a handful of the agent's
// own active listings to look real. Not the full picker list.
export const TOUR_INTRO_LISTING_LIMIT = 10;

// Falls back to the tour-only sample when the agent has no listings or the
// request fails, so the panel never shows the "no active MLS listing" state.
export const loadTourIntroProperties = async (tourListing) => {
  const response = await getMyMlsListings({
    page: 1,
    limit: TOUR_INTRO_LISTING_LIMIT,
    sortType: "NEWEST",
    status: "active",
  }).catch(() => null);
  const rows = (response?.data?.data || []).map((r) => ({
    mlsListingKey: r.ListingKey,
    Location: r.Location,
    photo: r.photo,
    AskingPrice: r.AskingPrice_Sell,
    selectable: true,
  }));
  return rows.length ? rows : [tourListing];
};
